import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatCargaHoraria'
})
export class FormatCargaHorariaPipe implements PipeTransform {

  transform(value: string): unknown {
    if (!value) {
      return '';
    }

    const linhas = value.split('\n');
    let resultado = '';

    linhas.forEach(linha => {
      // Remove asteriscos e espaços extras
      linha = linha.replace(/\*\*/g, '').trim();

      if (linha) {
        resultado += `<p>${linha}</p>`;
      }
    });

    return resultado;
  }

}
